/** 입·출고 진행중(P)·완료(E) 전표는 기존 isTransported와 동일하게 수정 잠금 */
export const isOrderLocked = (orderStatus?: string | null) =>
	orderStatus === 'P' || orderStatus === 'E';

/** 화면 입력값은 유지하고 orderStatus만 교체 */
export const applyOrderStatusOnly = <T extends { orderStatus?: string }>(
	row: T | undefined,
	orderStatus: string,
): T | undefined => {
	if (!row || row.orderStatus === orderStatus) return row;
	return { ...row, orderStatus };
};

/** 목록에서 대상 행의 orderStatus만 교체. 변경 없으면 원본 배열 유지 */
export const applyOrderStatusToList = <T extends { orderStatus?: string }>(
	list: T[],
	match: (row: T) => boolean,
	orderStatus: string,
): T[] => {
	if (!list.some((row) => match(row) && row.orderStatus !== orderStatus)) return list;
	return list.map((row) => match(row) ? { ...row, orderStatus } : row);
};
